import { useEffect, useState } from "react";

export type CountdownValue = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  expired: boolean;
};

const compute = (target: number): CountdownValue => {
  const diff = target - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff % 86_400_000) / 3_600_000);
  const minutes = Math.floor((diff % 3_600_000) / 60_000);
  const seconds = Math.floor((diff % 60_000) / 1000);
  return { days, hours, minutes, seconds, expired: false };
};

export const useCountdown = (targetDate: string): CountdownValue => {
  const target = new Date(targetDate).getTime();
  const [value, setValue] = useState<CountdownValue>(() => compute(target));

  useEffect(() => {
    setValue(compute(target));
    const id = setInterval(() => setValue(compute(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  return value;
};
